if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.submitButtons = document.querySelectorAll('.product-form__submit[type="button"]'); 
      if (document.querySelector('cart-drawer') && this.submitButton) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';

      this.confirmModalId = this.dataset.confirmModal || null;
      this.confirmSkuDescriptions = new Map();
      this.noticeModalId = this.dataset.noticeModal || null;
      this.noticeSkuDescriptions = new Map();
      this.variantSkuMap = {};

      if (this.confirmModalId) {
        const skusEl = document.getElementById(this.dataset.confirmSkusId);

        if (skusEl) {
          try {
            const groups = JSON.parse(skusEl.textContent);
            Object.values(groups || {}).forEach((group) => {
              (group.skus || []).forEach((sku) => {
                const trimmed = (sku || '').trim();
                if (trimmed) this.confirmSkuDescriptions.set(trimmed, group.description || '');
              });
            });
          } catch (e) {}
        }
      }

      if (this.noticeModalId) {
        const skusEl = document.getElementById(this.dataset.noticeSkusId);

        if (skusEl) {
          try {
            const group = JSON.parse(skusEl.textContent);
            (group.skus || []).forEach((sku) => {
              const trimmed = (sku || '').trim();
              if (trimmed) this.noticeSkuDescriptions.set(trimmed, group.description || '');
            });
          } catch (e) {}
        }
      }

      if (this.dataset.variantSkusId) {
        const variantsEl = document.getElementById(this.dataset.variantSkusId);

        if (variantsEl) {
          try {
            const data = JSON.parse(variantsEl.textContent);
            (data.ids || []).forEach((id, index) => {
              this.variantSkuMap[id] = (data.skus || [])[index];
            });
          } catch (e) {}
        }
      }
    }

    needsCartConfirm() {
      if (!this.confirmModalId || !this.confirmSkuDescriptions.size) return false;
      const variantId = this.form.querySelector('[name="id"]')?.value;
      const sku = this.variantSkuMap[variantId];
      return !!sku && this.confirmSkuDescriptions.has(sku.trim());
    }

    openCartConfirm() {
      const modal = document.getElementById(this.confirmModalId);
      if (!modal) {
        this.addToCart();
        return;
      }
      const variantId = this.form.querySelector('[name="id"]')?.value;
      const sku = (this.variantSkuMap[variantId] || '').trim();
      const description = this.confirmSkuDescriptions.get(sku);
      if (description) {
        const messageEl = modal.querySelector('.cart-confirm-modal__message');
        if (messageEl) messageEl.textContent = description;
      }
      modal.show(this.submitButton);
      modal.addEventListener('cartConfirmAccepted', () => this.addToCart(), { once: true });
    }

    showCartNoticeIfNeeded() {
      if (!this.noticeModalId || !this.noticeSkuDescriptions.size) return;
      const variantId = this.form.querySelector('[name="id"]')?.value;
      const sku = (this.variantSkuMap[variantId] || '').trim();
      const description = this.noticeSkuDescriptions.get(sku);
      if (!description) return;
      const modal = document.getElementById(this.noticeModalId);
      if (!modal) return;
      const messageEl = modal.querySelector('.cart-confirm-modal__message');
      if (messageEl) messageEl.textContent = description;
      modal.show(this.submitButton);
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      if (this.needsCartConfirm()) {
        this.openCartConfirm();
        return;
      }

      this.showCartNoticeIfNeeded();
      this.addToCart();
    }

    addToCart() {
      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      this.submitButtons.forEach((el)=>{
        el.setAttribute('aria-disabled', true);
        el.classList.add('loading');
        el.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      })

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            this.submitButtons.forEach((el)=>{
              el.setAttribute('aria-disabled', true);
              el.querySelector('span').classList.add('hidden');              
            })
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              // setTimeout(() => { this.cart.renderContents(response) });
              setTimeout(() => { this.cart.renderContents(response, false) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            // this.cart.renderContents(response);
            this.cart.renderContents(response, false);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          
          this.submitButtons.forEach((el)=>{
            el.classList.remove('loading');
            if (!this.error) el.removeAttribute('aria-disabled', true);            
            el.querySelector('.loading-overlay__spinner').classList.add('hidden');
          })
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

function initCartConfirmModals() {
  document.querySelectorAll('.cart-confirm-modal').forEach((modal) => {
    const confirmButton = modal.querySelector('.cart-confirm-modal__confirm');
    if (!confirmButton || confirmButton.dataset.bound) return;
    confirmButton.dataset.bound = 'true';
    confirmButton.addEventListener('click', () => {
      modal.dispatchEvent(new CustomEvent('cartConfirmAccepted'));
      modal.hide();
    });
  });
}

initCartConfirmModals();
document.addEventListener('shopify:section:load', initCartConfirmModals);
